export const ANALYTICS_DASHBOARD = '/analytic/dashboard'
